import ValidationInput from '@/components/ValidationInput.vue';
import CleaveInput from '@/components/CleaveInput.vue';
import DatepickerInput from '@/components/DatepickerInput.vue';
import OnOffSwitch from '@/components/OnOffSwitch.vue';

import Vue from 'vue';
import '@/router/guard';
import '@/shared/directives';
import '@/shared/modules';

Vue.component('ValidationInput', ValidationInput);
Vue.component('CleaveInput', CleaveInput);
Vue.component('DatepickerInput', DatepickerInput);
Vue.component('OnOffSwitch', OnOffSwitch);
